import { DocumentNumberSettingComponent } from './document-number-setting.component';
export var documentNumberSettingRoutes = [
    {
        path: 'document-number-setting',
        component: DocumentNumberSettingComponent,
        data: {
            'expectedRoles': ['Accountant Admin', 'Admin']
        }
    }
];
var DocumentNumberSettingRoutingModule = (function () {
    function DocumentNumberSettingRoutingModule() {
    }
    return DocumentNumberSettingRoutingModule;
}());
export { DocumentNumberSettingRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting-routing.module.ts.pre-build-optimizer.js